<template>
  <a-drawer
    :visible="visible"
    title="预览预病历"
    placement="right"
    :width="730"
    :maskClosable="false"
    @close="emit('cancel')"
    class="PreviewDrawer-drawer"
  >
    <div class="preview-modal">
      <div class="preview">
        <!-- 基础信息 -->
        <div class="preview__card">
          <div class="preview__info base-info">
            <div class="preview__info-item">
              <span class="label">患者姓名：</span>
              <span class="content">{{ info.patientName || '-' }}</span>
            </div>
            <div class="preview__info-item">
              <span class="label">性别：</span>
              <span class="content">{{ info.genderStr || '-' }}</span>
            </div>
            <div class="preview__info-item">
              <span class="label">年龄：</span>
              <span class="content">
                {{ info.patientAge != null ? info.patientAge : '-' }}
              </span>
            </div>
          </div>
          <div class="preview__info base-info">
            <div class="preview__info-item">
              <span class="label">医生姓名：</span>
              <span class="content">
                {{ info.doctorName || '-' }}
              </span>
            </div>
          </div>
        </div>
        <!-- 预问诊小结 -->
        <div class="preview__card">
          <div class="preview__title">预问诊小结</div>
          <div class="preview__info summary-info" v-if="info.consultationSummaryDTO">
            <div class="preview__info-item">
              <span class="label">用药状态：</span>
              <span class="content">
                {{
                  medicationStatusMap[info.consultationSummaryDTO.medicationStatus]?.label || '--'
                }}
              </span>
            </div>
            <div class="preview__info-item">
              <span class="label">用药清单：</span>
              <span class="content">
                <template
                  v-if="
                    info.consultationSummaryDTO.medicationSituation &&
                    info.consultationSummaryDTO.medicationSituation.length &&
                    info.consultationSummaryDTO.medicationSituation.some(s => s)
                  "
                >
                  <div :key="item" v-for="item in info.consultationSummaryDTO.medicationSituation">
                    {{ item }}
                  </div>
                </template>
                <template v-else>暂无</template>
              </span>
            </div>
            <div class="preview__info-item">
              <span class="label">用药说明：</span>
              <span class="content">
                {{ info.consultationSummaryDTO.medicationSupplementDescribe || '暂无' }}
              </span>
            </div>
          </div>
          <div class="preview__empty" v-else>暂无</div>
        </div>
        <!-- 诊断 -->
        <div class="preview__card">
          <div class="preview__info">
            <div class="preview__info-item">
              <span class="label">诊断：</span>
              <span class="content">{{ diagnosis }}</span>
            </div>
            <div
              class="preview__info-item"
              v-if="info.chineseDiagnosisVOList && info.chineseDiagnosisVOList.length"
            >
              <span class="label">中医证型：</span>
              <span class="content">
                {{ diagnosisType }}
              </span>
            </div>
            <div class="preview__info-item" v-if="info.remark">
              <span class="label">备注：</span>
              <span class="content">
                {{ info.remark || '--' }}
              </span>
            </div>
            <div class="preview__info-item" v-if="info.mainComplaint">
              <span class="label">主诉：</span>
              <span class="content">
                {{ info.mainComplaint || '--' }}
              </span>
            </div>
          </div>
          <!-- <div class="preview__empty" v-else>暂无</div> -->
        </div>
        <!-- 药品/健康用品 -->
        <div class="preview__card">
          <div class="preview__title">药品/健康用品</div>
          <div class="preview__info" v-if="(info.skuInfoList || []).length">
            <div class="sku-item" v-for="sku in info.skuInfoList" :key="sku.skuCode">
              <span class="left">{{ sku.skuName }}</span>
              <span class="right">
                <span class="x-unit">X</span>
                {{ sku.quantity }}
              </span>
            </div>
          </div>
          <div class="preview__empty" v-else>暂无</div>
        </div>
        <!-- 治疗费用 -->
        <div class="preview__card">
          <div class="preview__info treatment-cost">
            <div class="preview__info-item">
              <span class="label">诊后病程服务费</span>
              <span
                class="content text-right"
                v-if="rpMatchRecommendResponse"
                @click="openServiceFeeModal"
              >
                <!--                {{ '¥' + rpMatchRecommendResponse.courseDiseaseServiceFee ?? '-' }}-->
                <!-- <right-outlined class="icon" /> -->
                <img width="20" height="20" src="@/assets/img/right-icon.png" alt="/" />
              </span>
            </div>
          </div>
        </div>
        <!-- 预约复诊 -->
        <div class="preview__card">
          <div class="preview__title">预约复诊</div>
          <div class="revisitSummary-item">{{ revisitSummary }}</div>
        </div>
        <div class="preview__card" v-if="entrust">
          <div class="preview__title">嘱托</div>
          <div class="revisitSummary-item">{{ entrust || '--' }}</div>
        </div>
        <!-- 合计价格 -->
        <div class="preview__card" v-if="rpMatchRecommendResponse">
          <div class="preview__title">合计价格</div>
          <div class="amount-table">
            <div class="line top">
              <div class="cell">诊疗费</div>
              <div class="cell">医药费</div>
              <div class="cell">合计</div>
            </div>
            <div class="line bottom">
              <div class="cell">
                {{
                  rpMatchRecommendResponse.consultationFee
                    ? '¥' + rpMatchRecommendResponse.consultationFee
                    : '免费'
                }}
              </div>
              <div class="cell">{{ '¥' + medicineAmount }}</div>
              <div class="cell">{{ '¥' + rpMatchRecommendResponse.totalPrice }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="mode === 'edit'" class="preview-modal__footer">
        <a-button @click="handleCancel" style="margin-right: 8px">修改</a-button>
        <a-button type="primary" :loading="submitting" @click="handleConfirm">发送给医生</a-button>
      </div>
    </div>
  </a-drawer>

  <ServiceFeeModal
    v-model:visible="serviceFeeVisible"
    :egg-gold-amount="rpMatchRecommendResponse?.eggGoldAmount"
    :uc-doctor-id="serviceFeeDoctorId"
    :policy-fee="serviceFeePolicyFee"
    :service-package-code="servicePackageCode"
    @cancel="closeServiceFeeModal"
    @ok="closeServiceFeeModal"
  />
</template>

<script setup>
import { defineProps, defineEmits, computed, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { saveDoctorAssistantAdvanceMedicalRecord, rpMatchRecommend } from '@/api/HealthRecord'
import { Modal } from 'ant-design-vue'
import { medicationStatusMap } from './config'
import moment from 'moment'
import ServiceFeeModal from './ServiceFeeModal.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: 'edit'
  },
  detailData: {
    type: Object,
    default: () => ({})
  }
})

// 事件派发
const emit = defineEmits(['cancel', 'confirm'])
// 全局 store
const store = useStore()
// 预病历数据源
const preMedicalRecord = computed(() => store.state.preMedicalRecord || {})
// 预览信息：详情模式优先用 detailData
const info = computed(() =>
  props.mode === 'detail' ? props.detailData || {} : preMedicalRecord.value || {}
)
// 服务费弹窗显隐
const serviceFeeVisible = ref(false)
// rpMatchRecommend 接口返回的价格与推荐信息
const rpMatchRecommendResponse = ref(null)
// 诊疗费（元）
const payAmountYuan = computed(() => {
  return info.value.recommendCureParamVO?.payAmountYuan || 0
})
// 服务费弹窗 doctorId
const serviceFeeDoctorId = computed(
  () => info.value?.ucDoctorId ?? preMedicalRecord.value?.ucDoctorId ?? null
)
// 服务费弹窗 policyFee
const serviceFeePolicyFee = computed(() => {
  if (!rpMatchRecommendResponse.value) return '-'
  return rpMatchRecommendResponse.value.policyFee ?? '-'
})
// 服务费弹窗套餐编码
const servicePackageCode = computed(() => {
  return rpMatchRecommendResponse.value?.servicePackageCode || ''
})
// 提交中状态（防重复）
const submitting = ref(false)
// 将金额换算为“分”，用于规避浮点精度问题

const toCents = value => {
  const num = Number(value)
  if (Number.isNaN(num)) return 0
  return Math.round(num * 100)
}
// “分”转回“元”
// “分”转回“元”
const fromCents = cents => {
  const num = Number(cents)
  if (Number.isNaN(num)) return 0
  return num / 100
}
// 诊后病程服务费（扣减政策优惠后）
const courseServiceFeeAfterDiscount = computed(() => {
  if (!rpMatchRecommendResponse.value) return '-'
  const feeCents = toCents(rpMatchRecommendResponse.value.courseDiseaseServiceFee)
  const discountCents = toCents(rpMatchRecommendResponse.value.policyPreferentialFee)
  return fromCents(feeCents - discountCents)
})
// 医药费 = 药费 + 服务费 - 政策优惠
const medicineAmount = computed(() => {
  if (!rpMatchRecommendResponse.value) return '-'
  const drugFee = toCents(rpMatchRecommendResponse.value.drugFee)
  const courseDiseaseServiceFee = toCents(rpMatchRecommendResponse.value.courseDiseaseServiceFee)
  const policyPreferentialFee = toCents(rpMatchRecommendResponse.value.policyPreferentialFee)
  return fromCents(drugFee + courseDiseaseServiceFee - policyPreferentialFee)
})
// 嘱托合并展示
const entrust = computed(() => {
  const taboo = info.value.taboo || ''
  const advice = info.value.advice || ''
  return [taboo, advice].filter(Boolean).join('；')
})

// 复诊时段文案
const revisitDetailText = computed(() => {
  const value = info.value.revisitRemindInfo?.reserveDateDetail
  if (value === 1) return '上午'
  if (value === 2) return '下午'
  return '-'
})

// 复诊方式文案
const revisitTypeText = computed(() => {
  const value = info.value.revisitRemindInfo?.revisitType
  if (value === 1) return '线上咨询'
  if (value === 2) return '门诊就诊'
  return '-'
})

// 复诊信息汇总文案
const revisitSummary = computed(() => {
  const infoValue = info.value.revisitRemindInfo || {}
  if (infoValue.notNeedReserve) return '遵医嘱复诊'
  const reserveDate = infoValue.reserveDate
  if (!reserveDate) return '-'
  const date = moment(reserveDate).format('YYYY-MM-DD')
  const day = moment(reserveDate).format('dddd')
  const detail = revisitDetailText.value
  return `${date} ${day} ${detail} ｜ ${revisitTypeText.value}`
})
// 诊断（合并展示）
const diagnosis = computed(() => {
  if (!info.value.diagnosisVOList) return '--'
  const text = info.value.diagnosisVOList.map(m => m.name).join(';')
  return text || '--'
})
// 中医证型（合并展示）
const diagnosisType = computed(() => {
  if (!info.value.chineseDiagnosisVOList) return '--'
  const text = info.value.chineseDiagnosisVOList.map(m => m.name).join(';')
  return text || '--'
})
// 关闭预览
const handleCancel = () => {
  emit('cancel')
}

// 打开服务费弹窗
const openServiceFeeModal = () => {
  if (!rpMatchRecommendResponse.value) return
  serviceFeeVisible.value = true
}

// 关闭服务费弹窗
const closeServiceFeeModal = () => {
  serviceFeeVisible.value = false
}

// 提交预病历（防重复）
const handleConfirm = async () => {
  if (submitting.value) return
  submitting.value = true
  try {
    const { diagnosisVOList, chineseDiagnosisVOList } = info.value || {}
    const params = {
      ...info.value,
      diagnosisVOList: [
        ...(Array.isArray(diagnosisVOList) ? diagnosisVOList : []),
        ...(Array.isArray(chineseDiagnosisVOList) ? chineseDiagnosisVOList : [])
      ]
    }
    await saveDoctorAssistantAdvanceMedicalRecord(params)
    emit('confirm')
    Modal.success({
      title: '预病历提交成功',
      content: '请提醒医生至【医生工作台-预病历待办】中审核',
      okText: '知道了'
    })
  } catch (error) {
    console.error('发送失败:', error)
  } finally {
    submitting.value = false
  }
}

// 将 skuInfoList 格式化为 rpMatchRecommend 入参结构
// rpType: 协定方(7) -> 2，健康用品(4) -> 5，其它 -> 4
// sourceType 固定 1，仅 rpType=4 时需要 skuSourceList
const buildRpMedicationInfos = (skuList = info.value?.skuInfoList || []) => {
  const list = Array.isArray(skuList) ? skuList : []
  const rpMedicationInfos = list.map(item => {
    const skuType = item?.skuType
    const rpType = skuType === 7 ? 2 : skuType === 4 ? 5 : 4
    const rpNum = rpType === 4 ? Number(item?.quantity || 0) : String(item?.quantity || 0)
    const rpCode = item?.skuCode || ''
    const rpSkuId = item?.skuId != null ? String(item.skuId) : undefined

    if (rpType === 4) {
      return {
        rpType,
        rpNum,
        rpSkuId,
        rpCode,
        skuSourceList: [
          {
            sourceCode: rpCode,
            sourceType: 1,
            skuNum: Number(item?.quantity || 0),
            skuCode: rpCode
          }
        ]
      }
    }

    const base = { rpType, rpNum, rpCode }
    if (rpSkuId) base.rpSkuId = rpSkuId
    return base
  })

  return rpMedicationInfos
}

// 打开预览时触发价格匹配
watch(
  () => props.visible,
  async visible => {
    if (!visible) return
    await fetchRpMatchRecommend()
  }
)

// 归一化诊疗费：统一传数字类型（元），null/空串按 0 处理
const normalizeConsultationFee = fee => (fee === '' || fee == null ? null : Number(fee))
// 调用 rpMatchRecommend 并缓存结果
const fetchRpMatchRecommend = async () => {
  try {
    const payload = {
      ucDoctorId: info.value?.ucDoctorId || null,
      patientId: info.value?.patientId || null,
      newIncomeMode: true,
      // 处方模块中用户设置的诊疗费（元），由后端参与合计计算
      consultationFee: normalizeConsultationFee(info.value?.recommendCureParamVO?.payAmountYuan),
      rpMedicationInfos: buildRpMedicationInfos(info.value?.skuInfoList || [])
    }
    const response = await rpMatchRecommend(payload)
    rpMatchRecommendResponse.value = response
    return response
  } catch (error) {
    console.error('预览匹配推荐失败:', error)
    rpMatchRecommendResponse.value = null
    return null
  }
}
</script>
<style>
.PreviewDrawer-drawer .ant-drawer-body {
  margin-bottom: 0;
  padding: 0;
  height: calc(100% - 55px);
}
</style>
<style scoped lang="scss">
.preview-modal {
  position: relative;
  height: 100%;
  .preview {
    height: calc(100% - 55px);
    overflow-y: auto;
  }
  .preview-modal__footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
  }
}

.preview__card {
  border-top: 1px solid #ebebeb;
  padding: 20px 20px 0;
  margin-bottom: 20px;
  &:first-child {
    border: none;
  }
}
// 通用
.preview__info {
  .preview__info-item {
    margin-bottom: 20px;
    display: flex;
    .label {
      color: #999999;
      font-size: 14px;
      font-weight: 500;
      width: 75px;
      text-align: right;
    }
    .content {
      flex: 1;
      color: #333333;
      font-size: 14px;
      font-weight: 500;
      text-align: left;
    }
  }
}
// 基础信息
.base-info {
  display: flex;
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
  .preview__info-item {
    padding-right: 48px;
    border-right: 1px solid #e8e8e8;
    margin-left: 16px;
    margin-bottom: 0;
    &:last-child {
      border-right: none;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
// 小结
.summary-info {
  display: block;
}
// 药品/健康用品 sku-item
.sku-item,
.revisitSummary-item {
  background: #fafafa;
  padding: 12px;
  font-size: 16px;
  color: #333333;
  margin-bottom: 12px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  &:last-child {
    margin-bottom: 0;
  }
  .right {
    color: #666;
    .x-unit {
      font-size: 12px;
    }
  }
}
.treatment-cost {
  .preview__info-item {
    display: flex;
    justify-content: space-between;
    .label {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      width: auto;
    }
    .content {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
    }
    .text-right {
      cursor: pointer;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
// 合计费用
.amount-table {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  overflow: hidden;
  .line {
    font-size: 14px;
    display: flex;
    .cell {
      width: 33.3333%;
      padding: 8px 16px;
      border-right: 1px solid #e3e3e3;
      font-weight: 400;
      &:last-child {
        border-right: none;
      }
      .original-price {
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        margin-left: 2px;
        text-decoration: line-through;
      }
    }
  }
  .top {
    background: #fafafa;
    color: #666666;
    border-bottom: 1px solid #e3e3e3;
  }
  .bottom {
    background-color: white;
  }
}
.preview__title {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  margin-bottom: 16px;
}

.preview__value {
  font-size: 13px;
  color: #333;
  line-height: 20px;
}

.preview__empty {
  font-size: 12px;
  color: #999;
}

.preview__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.preview__list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  background: #fafafa;
  border-radius: 6px;
  font-size: 13px;
  color: #333;
}

.preview__list-qty {
  color: #666;
}
</style>
